import { RecoverPasswordComponent } from './../components/recover-password/recover-password.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecoverPasswordService {
  recoverPasswordModal: BsModalRef;

  constructor(private modalService: BsModalService) {}

  /**
   * Función para abrir modal
   * Este se abre en el componente de Login al dar clic en el botón de recuperar contraseña
   */
  openRecoverPasswordModal() {
    this.recoverPasswordModal = this.modalService.show(
      RecoverPasswordComponent,
      {
        class: 'modal-md modal-dialog-centered animated fadeIn',
        ignoreBackdropClick: true,
        keyboard: false
      }
    );
  }
}
